export { default } from "ember-basic-dropdown/components/basic-dropdown-wormhole";
